'use strict';
// https://github.com/zloirock/core-js/issues/280
var userAgent = require('../internals/engine-user-agent');

module.exports = /Version\/10(?:\.\d+){1,2}(?: [\w./]+)?(?: Mobile\/\w+)? Safari\//.test(userAgent);



//////////////////
// WEBPACK FOOTER
// ./~/handsontable/~/core-js/internals/string-pad-webkit-bug.js
// module id = 1210
// module chunks = 0